const defaultOptions = {
  dateStyle: 'short',
  timeStyle: 'short',
} as const satisfies Intl.DateTimeFormatOptions;

/**
 * Formats a date range using Elvia date format convention.
 *
 * @example
 * formatRange(sameDayStart, sameDayEnd)
 * // "02.09.2026, kl. 06.00–14.00"
 * @example
 * formatRange(crossDayStart, crossDayEnd)
 * // "02.09.2026, kl. 06.00–03.09.2026, kl. 14.00"
 */
export function formatRange(
  startDate: Date | number | bigint,
  endDate: Date | number | bigint,
  options: Intl.DateTimeFormatOptions = defaultOptions,
) {
  const formatter = new Intl.DateTimeFormat('nb-NO', options);
  const parts = formatter.formatRangeToParts(startDate, endDate);

  let addPrefix = true;
  let result = '';

  for (const part of parts) {
    // A new date starts here, so its time should get its own "kl."
    if (part.type === 'day') {
      addPrefix = true;
    }
    // Only the first hour after a date change gets prefixed
    if (part.type === 'hour' && addPrefix) {
      result += 'kl. ';
      addPrefix = false;
    }
    result += part.value;
  }

  // nb-NO uses ":" for time, but Elvia's format uses "."
  return result.replaceAll(':', '.');
}
